<template>
  <v-dialog transition="slide-x-transition" content-class="custom-dialog" v-model="showDialog" scrollable
    @input="onClose" width="500">
    <v-card class="right">
      <!-- Header -->
      <div
        style="width: 100%; height: 64px; padding: 8px 16px; left: 0; top: 0; position: relative; box-shadow: 2px 4px 8px rgba(0, 0, 0, 0.06); border-bottom: 1px #F2F2F2 solid; justify-content: flex-start; align-items: center; gap: 10px; display: inline-flex">
        <v-card-text
          style="flex: 1 1 0; color: #404040; font-size: 20px; font-family: Rubik; font-weight: 500; line-height: 36px; word-wrap: break-word">
          Filtrar
        </v-card-text>

        <img src="@/assets/img/close.svg" type="button" @click="onClose" alt="Close" />
      </div>

      <div style="overflow-y: scroll;">
        <!-- Options -->
        <div
          style="width: 100%; padding: 16px; left: 0; position: relative; flex-direction: column; justify-content: flex-start; align-items: flex-start; display: inline-flex">
          <div style="width: 100%" v-if="section?.type === 'patient'">
            <div class="title">
              Estado del tratamiento
            </div>

            <v-select style="width: 100%; margin-top: 8px" label="Todos los pacientes" v-model="selectedPatientStatus"
              item-text="name" item-value="value" dense solo flat outlined :items="patientStatusList" return-object />
          </div>

          <div style="width: 100%" v-if="section?.type === 'income' || section?.type === 'appointment'">
            <div class="title">
              Plataforma
            </div>

            <v-select style="width: 100%; margin-top: 8px" v-model="selectedPlatform" item-text="name"
              item-value="value" dense solo flat outlined :items="platformList" return-object />
          </div>

          <div style="width: 100%">
            <div class="title">
              Profesional
            </div>

            <v-select style="width: 100%; margin-top: 8px" label="Todos los profesionales"
              v-model="selectedProfessional" item-text="name" item-value="id" dense solo flat outlined
              :items="professionalList" return-object />
          </div>

          <div style="width: 100%">
            <div class="title">
              Especialidad
            </div>

            <v-select label="Todas las especialidades" v-model="selectedSpeciality" item-text="name" item-value="id"
              outlined dense solo flat style="width: 100%; margin-top: 8px" :items="specialityList" return-object />
          </div>

          <div style="width: 100%" v-if="section?.type !== 'queryPerPatient'">
            <div class="title">
              Consulta
            </div>

            <v-select label="Todas las consultas" v-model="selectedAppointmentSession" item-text="name"
              item-value="value" outlined dense solo flat style="width: 100%; margin-top: 8px"
              :items="appointmentSessionsList" return-object />
          </div>

          <div style="width: 100%" v-if="section?.type !== 'queryPerPatient'">
            <div class="title">
              Mes
            </div>

            <v-select style="width: 100%; margin-top: 8px" label="Todos los meses" v-model="selectedMonth"
              item-text="name" item-value="value" outlined dense solo flat :items="monthList" return-object />
          </div>

          <div style="width: 100%" v-if="section?.type !== 'queryPerPatient'">
            <div class="title">
              Año
            </div>

            <v-select style="width: 100%; margin-top: 8px" label="Todos los años" v-model="selectedYear"
              item-text="name" item-value="value" outlined dense solo flat :items="yearList" return-object />
          </div>
        </div>

        <!-- Footer -->
        <v-card-actions>
          <div
            style="width: 100%; background: white; justify-content: center; align-items: center; gap: 14px; display: inline-flex">
            <v-btn @click="onClickClear" rounded variant="outlined"
              style="color: #404040; font-size: 16px; font-family: Plus Jakarta Sans; font-weight: 600; line-height: 24px; word-wrap: break-word; border: thin solid #595959; background: transparent;  text-transform: none;">
              Borrar todos
            </v-btn>

            <v-btn @click="onClickApply" rounded
              style="color: white; font-size: 16px; font-family: Plus Jakarta Sans; font-weight: 600; line-height: 24px; word-wrap: break-word; background: #F48020;  text-transform: none;">
              Aplicar filtros
            </v-btn>
          </div>
        </v-card-actions>
      </div>
    </v-card>
  </v-dialog>
</template>

<style scoped lang="scss">
.right {
  position: absolute;
  width: 400px;
  top: 0;
  right: 0;
  margin: 0;
  min-height: 100%;
}

.title {
  color: #404040;
  font-size: 16px;
  font-family: Plus Jakarta Sans;
  font-weight: 600;
  line-height: 24px;
  word-wrap: break-word;
}
</style>

<script>
import moment from "moment";

export default {
  name: "ModalFilter",
  props: {
    showDialog: {
      type: Boolean,
      default: false
    },
    section: {
      type: Object,
      default: null
    }
  },

  data: () => ({
    appointmentSessionsList: [
      {
        value: "all",
        name: "Todas las consultas"
      },
      {
        value: "first",
        name: "Primeras (1)"
      },
      {
        value: "second",
        name: "Segundas (2)"
      },
      {
        value: "first_and_second",
        name: "Primeras y segundas (1 y 2)"
      },
      {
        value: "three_or_more",
        name: "Terceras en adelante (3+)"
      }
    ],
    specialityList: [
      {
        id: "",
        name: "Todas las especialidades"
      }
    ],
    professionalList: [
      {
        id: "",
        name: "Todos los profesionales"
      }
    ],
    patientStatusList: [
      {
        value: "",
        name: "Todos los pacientes"
      },
      {
        value: "in_progress",
        name: "En Progreso"
      },
      {
        value: "inactive",
        name: "Inactivo"
      },
      {
        value: "discharged",
        name: "Dado de alta"
      },
      {
        value: "potential",
        name: "Potencial"
      }
    ],
    platformList: [
      {
        value: "ars",
        name: "Mercado Pago"
      },
      {
        value: "usd",
        name: "Stripe"
      }
    ],
    monthList: [
      {
        value: "",
        name: "Todos los meses"
      },
      {
        value: "01",
        name: "Enero"
      },
      {
        value: "02",
        name: "Febrero"
      },
      {
        value: "03",
        name: "Marzo"
      },
      {
        value: "04",
        name: "Abril"
      },
      {
        value: "05",
        name: "Mayo"
      },
      {
        value: "06",
        name: "Junio"
      },
      {
        value: "07",
        name: "Julio"
      },
      {
        value: "08",
        name: "Agosto"
      },
      {
        value: "09",
        name: "Septiembre"
      },
      {
        value: "10",
        name: "Octubre"
      },
      {
        value: "11",
        name: "Noviembre"
      },
      {
        value: "12",
        name: "Diciembre"
      }
    ],
    yearList: [
      {
        value: "",
        name: "Todos los años"
      }
    ],

    selectedAppointmentSession: null,
    selectedSpeciality: null,
    selectedProfessional: null,
    selectedPatientStatus: null,
    selectedMonth: null,
    selectedYear: null,
    selectedPlatform: null
  }),

  created() {
    this.updateProfessionals();
    this.$store.dispatch("Specialities/getListAll").then(response => {
      this.specialityList.push(...response);
    });

    for (let index = 0; index < 10; index++) {
      const year = moment()
        .subtract(index, "year")
        .format("YYYY");
      this.yearList.push({ value: `${year}`, name: `${year}` });
    }
  },

  watch: {
    section(val) {
      this.value = val;
      this.selectedPlatform = null

      if (val?.filters) {
        for (let filter of val.filters) {
          switch (filter.type) {
            case "appointment_session":
              this.selectedAppointmentSession = filter.selection;
              break;

            case "speciality":
              this.selectedSpeciality = filter.selection;
              break;

            case "platform":
              this.selectedPlatform = filter.selection;
              break;

            case "professional":
              this.selectedProfessional = filter.selection;
              break;

            case "patient_status":
              this.selectedPatientStatus = filter.selection;
              break;

            case "month":
              this.selectedMonth = filter.selection;
              break;

            case "year":
              this.selectedYear = filter.selection;
              break;
          }
        }
      }

      this.updateProfessionals();
    },

    selectedPlatform(val) {
      this.value = val;
      //if (this.selectedPlatform) this.updateProfessionals();
    }
  },

  methods: {
    updateProfessionals() {
      this.$store
        .dispatch("Professionals/getListAll"/*, {
          work_abroad:
            this.selectedPlatform?.value === "ars"
              ? "local"
              : this.selectedPlatform?.value === "usd"
                ? "abroad"
                : "all"
        }*/)
        .then(response => {
          this.professionalList = [
            {
              id: "",
              name: "Todos los profesionales"
            }
          ];
          for (let professional of response) {
            this.professionalList.push({
              id: professional.id,
              name: professional.first_name + " " + professional.last_name
            });
          }
        });
    },

    onClose() {
      this.$emit("close");
      this.onClickClear();
    },

    onClickApply() {
      this.section.filters = [];

      if (this.selectedAppointmentSession) {
        this.section.filters.push({
          type: "appointment_session",
          selection: this.selectedAppointmentSession
        });
      }

      if (this.selectedSpeciality) {
        this.section.filters.push({
          type: "speciality",
          selection: this.selectedSpeciality
        });
      }

      if (this.selectedPlatform) {
        this.section.filters.push({
          type: "platform",
          selection: this.selectedPlatform
        });
      }

      if (this.selectedProfessional) {
        this.section.filters.push({
          type: "professional",
          selection: this.selectedProfessional
        });
      }

      if (this.selectedPatientStatus) {
        this.section.filters.push({
          type: "patient_status",
          selection: this.selectedPatientStatus
        });
      }

      if (this.selectedMonth) {
        this.section.filters.push({
          type: "month",
          selection: this.selectedMonth
        });
      }

      if (this.selectedYear) {
        this.section.filters.push({
          type: "year",
          selection: this.selectedYear
        });
      }

      this.onClose();
    },

    onClickClear() {
      this.selectedYear = null;
      this.selectedMonth = null;
      this.selectedSpeciality = null;
      this.selectedProfessional = null;
      this.selectedPatientStatus = null;
      this.selectedAppointmentSession = null;
    }
  }
};
</script>
